import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "organizationDocument";

export const useOrganizationDocumentStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "attributes.name");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchAll, baseSave, baseDelete, baseMultipartPost } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("organization-documents", errorCallback);
  };

  const create = async (formData, callback, errorCallback) => {
    await baseMultipartPost("organization-documents", formData, async (created) => {
      await fetchAll();
      callback && callback(created);
    }, errorCallback);
  };

  const update = async (documentData, callback, errorCallback) => {
    await baseSave("organization-documents", documentData, async (updated) => {
      await fetchAll();
      callback && callback(updated);
    }, errorCallback);
  };

  const addVersion = async (documentId, formData, callback, errorCallback) => {
    await baseMultipartPost(`organization-documents/${documentId}/versions`, formData, async (updated) => {
      await fetchAll();
      callback && callback(updated);
    }, errorCallback);
  };

  const destroy = async (id, callback, errorCallback) => {
    await baseDelete("organization-documents", id, async () => {
      await fetchAll();
      callback && callback();
    }, errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
  });

  return {
    all,
    addVersion,
    create,
    currentPage,
    destroy,
    fetchAll,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: paginatedResources,
    paginationRange,
    searchQuery,
    sorted: sortedResources,
    totalPages,
    update,
  };
});
